import { css } from "lit";

/**
 * Custom light theme — "Sky & Clouds"
 *
 * Sky blue page, white cards floating like clouds.
 * Black text on white for maximum contrast.
 * Red accent for selected/active elements.
 * Yellow for secondary actions (sunshine).
 * Very rounded corners for a soft, toylike feel.
 */
export const customLightThemeVars = css`
  /* Application Variables */
  --bab-bg: #fefce8;              /* Soft lemon yellow */
  --bab-card-bg: #ffffff;         /* Cloud white */
  --bab-text: #000000;            /* Black */
  --bab-text-secondary: #1d4ed8;  /* Playground blue — 7.6:1 on yellow */
  --bab-border: #000000;          /* Black outline */
  --bab-accent: #be185d;          /* Dragonfruit pink — 6.6:1 on yellow */
  --bab-banner-bg: #fef9c3;       /* Deeper yellow tint */
  --bab-banner-text: #854d0e;     /* Brownish yellow text */
  --bab-banner-border: #facc15;   /* Golden border */
  --bab-input-bg: #ffffff;
  --bab-input-text: #000000;
  --bab-button-secondary-bg: #22c55e; /* Crayola green */
  --bab-button-secondary-text: #000000; /* Black on green — 8.2:1 */
  --bab-delta-pos: #15803d;
  --bab-delta-pos-bg: #dcfce7;
  --bab-delta-neg: #991b1b;
  --bab-delta-neg-bg: #fee2e2;

  /* Structural */
  --bab-border-width: 3px;
  --bab-radius: 18px;             /* Very rounded — bubbly, toylike */
  --bab-font-weight: 900;
`;

/**
 * Custom dark theme — "Midnight Navy"
 *
 * Deep navy background like a night sky.
 * White text, yellow secondary (stars).
 * Red for active/selected elements.
 * Green secondary button. Yellow banner — most visible against navy.
 */
export const customDarkThemeVars = css`
  /* Application Variables */
  --bab-bg: #0a1628;              /* Deep navy night sky */
  --bab-card-bg: #142038;         /* Slightly lighter navy for cards */
  --bab-text: #ffffff;            /* White */
  --bab-text-secondary: #ffe000;  /* Yellow — stars */
  --bab-border: #ffffff;          /* White outlines */
  --bab-accent: #e879f9;          /* Electric purple — 6.2:1 on card navy */
  --bab-banner-bg: #1a3a6a;       /* Medium navy */
  --bab-banner-text: #ffe000;     /* Yellow text */
  --bab-banner-border: #2a5a9a;   /* Medium blue border */
  --bab-input-bg: #0a1628;
  --bab-input-text: #ffffff;
  --bab-button-secondary-bg: #00bb44; /* Neon green */
  --bab-button-secondary-text: #000000; /* Black on green — 9.5:1 */
  --bab-delta-pos: #4ade80;
  --bab-delta-pos-bg: rgba(74, 222, 128, 0.15);
  --bab-delta-neg: #fca5a5;
  --bab-delta-neg-bg: rgba(252, 165, 165, 0.15);

  /* Structural */
  --bab-border-width: 3px;
  --bab-radius: 12px;
  --bab-font-weight: 900;
`;
